import type {AssetGalleryAsset} from '@netx/core-asset-gallery/types';
import {type IAsset} from '@netx/core-asset-next/schema';
import {PermissionMatrixName} from '@netx/core-permissions/constants';
import {allows} from '@netx/core-permissions/utils';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {MINIMUM_USER_LEVEL} from './constants';
import {assetExpires} from './utils';

export const assetExpirationEnabled = () =>
	getPreference('asset.expire.enabled', true);

export const canModifyAssetExpiration = (asset: AssetGalleryAsset | IAsset) =>
	assetExpirationEnabled() &&
	currentUserMeetsUserLevel(MINIMUM_USER_LEVEL) &&
	allows(asset.permissionMatrix, PermissionMatrixName.DELETE);

export const canExpireAsset = (asset: AssetGalleryAsset | IAsset) =>
	!assetExpires(asset) && canModifyAssetExpiration(asset);

export const canUnexpireAsset = (asset: AssetGalleryAsset | IAsset) =>
	assetExpires(asset) && canModifyAssetExpiration(asset);
